import {ArcElement, Chart as ChartJS} from "chart.js"
import {Doughnut} from "react-chartjs-2"
import React, {useMemo} from "react"
import {Box, styled, Typography} from "@mui/material"

ChartJS.register(ArcElement)

const chartOptions = {
    responsive: true,
    borderColor: "transparent",
    hoverBorderColor: "transparent",
    maintainAspectRatio: false,
    cutout: "65%",
    plugins: {
        tooltip: {enabled: false},
        legend: {display: false},
    },
}

const DonutWrapper = styled(Box)({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "8px",
})

const ChartContainer = styled(Box)({
    position: "relative",
    width: "180px",
    height: "180px",
})

const CenterLabel = styled(Typography, {
    shouldForwardProp: (prop) => prop !== "disabled",
})(({_, disabled}) => ({
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    textAlign: "center",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: 1.2,
    maxWidth: "90px",
    color: disabled ? "#7C8A98" : "#000000"
}))

const StackedDonutWidget = ({value}) => {
    const {
        centerLabel = "",
        segments = [],
        labelDisabled = false
    } = value ?? {}

    const chartData = useMemo(() => {
        const data = segments.map((s) => s.value)
        const backgroundColor = segments.map((s) => s.color)
        return {
            datasets: [{data, backgroundColor}],
        }
    }, [segments])

    return (
        <DonutWrapper>
            <ChartContainer>
                <Doughnut data={chartData} options={chartOptions} />
                <CenterLabel disabled={labelDisabled}>{centerLabel}</CenterLabel>
            </ChartContainer>
        </DonutWrapper>
    )
}

export default StackedDonutWidget
